import React from 'react';
import styled from 'styled-components';
import { BookOpen, NotebookText } from 'lucide-react';
import { Note, isSource } from '@annote/types';
import { colors } from '@annote/core/styles';
import { usePanelContext } from 'src/context/PanelContext';
import { CardButton } from './CardButton';

const StyledCardButton = styled(CardButton)<{ $isSelected: boolean }>`
  button {
    background-color: ${(props) => (props.$isSelected ? colors.button.selected : 'transparent')};
  }
`;

// Opens sources in reader panel, takeaways in writer panel
// If already active, closes the panel (unpins)
export const OpenInPanelButton: React.FC<{ note: Note }> = ({ note }) => {
  const { panels, openPanel, setActiveId, closePanel } = usePanelContext();

  const isSrc = isSource(note);
  const icon = isSrc ? BookOpen : NotebookText;
  const panelId = isSrc ? 'reader' : 'writer';

  // Check if this note is currently active in its panel and panel is open
  const isActive = panels[panelId].activeId === note.id && panels[panelId].isOpen;

  const handleClick = (): void => {
    if (isActive) {
      // Already active and panel is open - close the panel (unpin)
      closePanel(panelId);
    } else {
      // Not active or panel closed - open it
      setActiveId(panelId, note.id);
      openPanel(panelId, note.id);
    }
  };

  return <StyledCardButton iconSVG={icon} onClick={handleClick} $isSelected={isActive} />;
};
